import * as React from "react";
import { Form, Input } from "antd";
import { EvaluationTypeFormFields } from "../../../common/Constants";
import { IEvaluationType } from "../../../model/evaluation/EvaluationType";

const EvaluationTypeForm = ({
  getFieldDecorator,
  translate,
  rowData
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: IEvaluationType;
}) => {
  return (
    <Form>
      <Form.Item label={translate("evaluationType_form.name")}>
        {getFieldDecorator(EvaluationTypeFormFields.Fields.NAME, {
          initialValue: rowData && rowData.name,
          rules: [
            {
              required: true,
              message: translate("evaluationType_form.required_messages", {
                field: translate("evaluationType_form.name")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label={translate("evaluationType_form.description")}>
        {getFieldDecorator(EvaluationTypeFormFields.Fields.DESCRIPTION, {
          initialValue: rowData && rowData.description,
          rules: [
            {
              required: true,
              message: translate("evaluationType_form.required_messages", {
                field: translate("evaluationType_form.description")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>
    </Form>
  );
};

export default EvaluationTypeForm;
